import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import { ECasinoGameView } from 'interfaces/casino-data';

export type GameViewContainerProps = {
  view: ECasinoGameView;
  onViewChange: (view: ECasinoGameView) => void;
  externalCategory?: string;
  mainCategory: string;
  sameGameNoticeOpen: boolean;
  setSameGameNoticeOpen: (value: boolean) => void;
};

export type CasinoGameViewContainerProviderProps = {
  children: ReactNode;
  value: GameViewContainerProps;
};

const CasinoGameViewContainerContext = createContext<
  CasinoGameViewContainerProviderProps['value']
>({
  view: ECasinoGameView.SINGLE,
  onViewChange: () => {},
  mainCategory: CUSTOM_CATEGORIES.all.id,
  sameGameNoticeOpen: false,
  setSameGameNoticeOpen: () => {}
});

export const CasinoGameViewContainerProvider = (
  props: CasinoGameViewContainerProviderProps
): ReactElement => {
  return (
    <CasinoGameViewContainerContext.Provider value={props.value}>
      {props.children}
    </CasinoGameViewContainerContext.Provider>
  );
};

export const useCasinoGameViewContainerValues =
  (): CasinoGameViewContainerProviderProps['value'] => {
    return useContext(CasinoGameViewContainerContext);
  };
